export default __webpack_public_path__ + "static/media/oferta-especial.6b0841ac.svg";